import {
	ChangeDetectionStrategy,
	Component,
	EventEmitter,
	Input,
	Output,
} from '@angular/core';
import { ICON } from '@core/util/icon';
import { TreefortIdentification } from '@models/idv';
import {
	AnalyticsEvent,
	AnalyticsService,
} from '@services/analytics/analytics.service';
import { DropdownResult } from 'src/app/shared/atomic/atoms/dropdown-options/dropdown-options.component';
import { IDLabels, IDMapping, Ids } from 'src/app/shared/data/Identification';

@Component({
	selector: 'app-id-details',
	templateUrl: './id-details.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false,
})
export class IdDetailsComponent {
	public ICON = ICON;
	public IDLabels = IDLabels;
	public id: TreefortIdentification;
	public Ids = Ids;
	public selectedID: IDMapping = null;
	public treefortSyncAvailable = false;
	public syncText = '';
	public syncTooltip = '';
	public syncIcon: string;
	public _isSecondId: boolean;

	@Input() public editable = false;
	@Input() public initiatorName: string;
	@Input() set isSecondId(value: boolean) {
		this._isSecondId = value;
		this.treefortSyncAvailable = !value;
		this.setSyncText(this.treefortSyncAvailable);
	}

	@Input() set identification(value: TreefortIdentification) {
		this.id = value;

		if (this.id?.type) {
			this.selectedID = Ids.find((x) => x?.closerId === this.id?.type);
		} else if (this.id?.documentType) {
			this.selectedID = null;
			this.Ids = Ids.filter(
				(id) => id.treefortCorrespondingDocumentType === this.id?.documentType,
			);
		}
	}

	@Output() identificationChange = new EventEmitter<TreefortIdentification>();

	constructor(private analyticsService: AnalyticsService) {}

	_setType(value: DropdownResult<IDMapping>) {
		this.emitIdChange({ type: value.result.closerId });
		this.selectedID = Ids.find((x) => x?.closerId === value.result?.closerId);
	}

	_setNumber(value: string): void {
		this.emitIdChange({ number: value });
	}

	_setExpirationDate(value: string): void {
		this.emitIdChange({ expirationDate: value });
	}

	_setJurisdiction(value: string): void {
		this.emitIdChange({ jurisdiction: value });
	}

	_setCountry(value: string): void {
		this.emitIdChange({ country: value });
	}

	_setVerifiedBy(value: string): void {
		this.emitIdChange({ verifiedBy: value });
	}

	_setVerifiedDate(value: string): void {
		this.emitIdChange({ dateOfVerification: value });
	}

	_setFullName(value: string): void {
		this.emitIdChange({ fullName: value });
	}

	private emitIdChange(id: Partial<TreefortIdentification>) {
		this.logEvent();
		this.identificationChange.emit({ ...this.id, ...id });
	}

	private logEvent(): void {
		if (!this._isSecondId) {
			this.analyticsService.logEvent(
				AnalyticsEvent.TREEFORT_SYNC_ID_FIELD_CHANGE,
			);
		}
	}

	private setSyncText(treefortSyncAvailable: boolean): void {
		if (treefortSyncAvailable) {
			this.syncIcon = ICON.REFRESH;
			this.syncText = 'synced from Treefort';
			this.syncTooltip = '';
		} else {
			this.syncIcon = ICON.INFO;
			this.syncText = 'sync unavailable';
			this.syncTooltip =
				'Treefort’s ID verification service does not currently provide details for ID 2';
		}
	}
}
